import React from "react";
import { ArrowUpIcon, ArrowDownIcon } from "lucide-react";
import "./TotalCard.scss";

const TotalCard = ({
  title = "TOTAL AGENT'S COMMISSION",
  value,
  lastMonthValue,
  negative = false,
  image,
  date,
}) => {
  // Handle case when lastMonthValue is 0 to avoid division by zero
  const percentageChange =
    lastMonthValue !== 0
      ? (((value - lastMonthValue) / Math.abs(lastMonthValue)) * 100).toFixed(2)
      : "0.00";

  // Determine if it's a positive change
  const isPositiveChange = negative
    ? parseFloat(percentageChange) < 0
    : parseFloat(percentageChange) > 0;

  const ChangeIcon = isPositiveChange ? ArrowUpIcon : ArrowDownIcon;

  // console.log(percentageChange === "Infinity");

  return (
    <div className="commission-card">
      <div className="commission-card__title-cost">
        <div>
          <img src={image} alt="icon-cost" />
        </div>
        <p>
          {title}
          {/* ({date}) */}
        </p>
      </div>

      <div className="commission-card__value-cost">
        <div>
         <p>${Number(value).toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 })}</p>

        </div>
        <div
          className={`commission-card__change-cost ${
            isPositiveChange
              ? "commission-card__change--positive"
              : "commission-card__change--negative"
          }`}
          style={{ display: lastMonthValue[0] === undefined ? "none" : "" }}
        >
          <ChangeIcon size={16} className="commission-card__change-icon" />
          <span>
            {percentageChange === "Infinity" ? 0 : Math.abs(percentageChange)}%
          </span>
        </div>
      </div>

      <div className="commission-card__last-month-other-cost">
        <p>Last month</p>
        <p>${Number(lastMonthValue).toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 })}</p>
      </div>
    </div>
  );
};

export default TotalCard;
